import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Zap, Store, BarChart3, Wallet } from 'lucide-react';
import { Button } from '../ui/button';
import { useApp } from '../../context/AppContext';

const DashboardPreview = () => {
  const { t } = useApp();
  const metrics = [
    { id: 'views', label: t('land.listingViews'), v: 92, val: '24.8K' },
    { id: 'conv', label: t('land.convRate'), v: 76, val: '8.4%' },
    { id: 'rating', label: t('land.sellerRating'), v: 96, val: '4.9 / 5' },
  ];
  return (
    <div className="relative bg-white rounded-3xl shadow-xl border border-[#EFEAE0] p-6 md:p-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <div className="text-xs uppercase tracking-wider text-[#7A7468] font-semibold">{t('land.dashboard')}</div>
          <div className="text-lg font-bold text-[#1A1A1A]">Aïssata Diop</div>
        </div>
        <div className="px-3 py-1 rounded-full bg-[#F2B441]/20 text-[#8B6914] text-xs font-bold">PRO</div>
      </div>
      <div className="grid grid-cols-2 gap-3 mb-6">
        <div className="p-4 bg-[#FAF7F2] rounded-xl">
          <div className="text-xs text-[#7A7468] mb-1">{t('land.monthRevenue')}</div>
          <div className="text-2xl font-black text-[#1A1A1A]">847K <span className="text-sm font-medium text-[#7A7468]">CFA</span></div>
          <div className="text-xs text-[#0F8B5C] font-semibold mt-1">↗ {t('land.vsLast')}</div>
        </div>
        <div className="p-4 bg-[#FAF7F2] rounded-xl">
          <div className="text-xs text-[#7A7468] mb-1">{t('land.activeListings')}</div>
          <div className="text-2xl font-black text-[#1A1A1A]">42</div>
          <div className="text-xs text-[#0F8B5C] font-semibold mt-1">{t('land.boostedCount')}</div>
        </div>
      </div>
      <div className="space-y-3">
        <div className="text-xs uppercase tracking-wider text-[#7A7468] font-semibold mb-2">{t('land.performance')}</div>
        {metrics.map((m) => (
          <div key={m.id}>
            <div className="flex justify-between text-xs mb-1"><span className="text-[#3F3A30]">{m.label}</span><span className="font-bold text-[#1A1A1A]">{m.val}</span></div>
            <div className="h-2 bg-[#FAF7F2] rounded-full overflow-hidden"><div className="h-full rounded-full bg-gradient-to-r from-[#0F8B5C] to-[#F2B441] transition-all duration-1000" style={{ width: `${m.v}%` }} /></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const Monetization = () => {
  const { t } = useApp();
  const bullets = [
    { id: 'b1', icon: Zap, txt: t('monet.b1') }, { id: 'b2', icon: Store, txt: t('monet.b2') },
    { id: 'b3', icon: BarChart3, txt: t('monet.b3') }, { id: 'b4', icon: Wallet, txt: t('monet.b4') },
  ];
  return (
    <section className="bg-[#FAF7F2] py-20" data-testid="landing-monetization-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#F2B441]/20 text-[#8B6914] text-xs font-semibold uppercase tracking-wider mb-6"><Wallet className="w-3.5 h-3.5" /> {t('monet.eyebrow')}</span>
            <h2 className="text-4xl md:text-5xl font-black tracking-tight text-[#1A1A1A] leading-tight">{t('monet.title')}</h2>
            <p className="mt-4 text-lg text-[#3F3A30] max-w-lg">{t('monet.subtitle')}</p>
            <ul className="mt-8 space-y-3">
              {bullets.map((b) => (
                <li key={b.id} className="flex items-center gap-3 text-[#1A1A1A]">
                  <div className="w-8 h-8 rounded-lg bg-white border border-[#EFEAE0] flex items-center justify-center shrink-0"><b.icon className="w-4 h-4 text-[#0F8B5C]" /></div>
                  <span className="font-medium">{b.txt}</span>
                </li>
              ))}
            </ul>
            <Link to="/pricing"><Button size="lg" className="mt-8 bg-[#1A1A1A] hover:bg-[#0F8B5C] text-white" data-testid="landing-pricing-cta">{t('monet.cta')} <ArrowRight className="w-4 h-4 ml-2" /></Button></Link>
          </div>
          <DashboardPreview />
        </div>
      </div>
    </section>
  );
};
